import React, { ReactElement } from 'react'
import { Accordion, Pill } from '@scentregroup/ui'
import styles from './index.scss'

interface FiltersSmall {
  children: ReactElement
  countDisplay: string
  onClick: Function
}

const FiltersSmall = ({
  children,
  countDisplay,
  onClick,
}: FiltersSmall): JSX.Element => (
  <Accordion
    headerElement={
      <>
        <span>Filters</span>
        <Pill
          className={styles.accordionCount}
          type="secondary"
          dataTestId="whats-happening-items-count-small"
        >
          {countDisplay}
        </Pill>
      </>
    }
    visible={false}
    type="small"
    classNames={styles}
    id="whats-happening-filters"
    onClick={onClick}
  >
    {children}
  </Accordion>
)

export default FiltersSmall
